import { render, staticRenderFns } from "./LiteDescription.vue?vue&type=template&id=895cb0fe&scoped=true&"
import script from "./LiteDescription.vue?vue&type=script&lang=js&"
export * from "./LiteDescription.vue?vue&type=script&lang=js&"
import style0 from "./LiteDescription.vue?vue&type=style&index=0&id=895cb0fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895cb0fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VImg,VRow,VSimpleTable})
